import React from 'react';
import DOMPurify from 'dompurify';
import { Icon, Haldor__Block, addBlockTranslations } from '@haldor/ui';
import { Editor as HTMLEditor } from "UI/Inputs";
import AIPrompt from './AIPrompt';
import './_AIEditor.scss';
import User from "_class/User";
class AIEditor extends Haldor__Block {

	constructor(props) {
		super(props);

		this.state = {
			modal: false,
			textvalue: '',
		}

		this.name = 'Haldor.Blocks.AIEditor';
		this.order = 46;
		this.icon = () => (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"
				dangerouslySetInnerHTML={{
					__html: `
							<defs>
								<style>.editor-icon{fill:#c8c9c8;}</style>
							</defs>
							<path class="editor-icon" d="M46.79,39.72,41,29.79A1.76,1.76,0,0,0,39.5,29h0a1.78,1.78,0,0,0-1.55.84l-2,3.47-5.33-8.41a1.77,1.77,0,0,0-1.51-.79h0a1.75,1.75,0,0,0-1.5.79L18.22,39.66a1.8,1.8,0,0,0,0,1.81,1.78,1.78,0,0,0,1.56.93H45.25a1.79,1.79,0,0,0,1.54-2.68Zm-26.32.45L29,26.64,36,37.57l3.46-6,5,8.59Z"/>
							<path class="editor-icon" d="M36.33,18.38a4,4,0,1,0,4,4A4,4,0,0,0,36.33,18.38Zm0,6.11a2.1,2.1,0,1,1,2.09-2.09A2.1,2.1,0,0,1,36.33,24.49Z"/>
							<path class="editor-icon" d="M28.14,12.8H5.57a2.6,2.6,0,0,1,0-5.2H28.14a2.6,2.6,0,0,1,0,5.2Z"/>
							<path class="editor-icon" d="M18.54,27.6h-13a2.6,2.6,0,0,1,0-5.2h13a2.6,2.6,0,0,1,0,5.2Z"/>
							<path class="editor-icon" d="M9.72,42.4H5.57a2.6,2.6,0,0,1,0-5.2H9.72a2.6,2.6,0,1,1,0,5.2Z"/>
						`
				}}
			/>
		);

		addBlockTranslations('sv-se', [
			{
				output: 'AI Editor',
				id: 'Haldor.Blocks.AIEditor',
			}
		]);

		addBlockTranslations('en-us', [
			{
				output: 'AI Editor',
				id: 'Haldor.Blocks.AIEditor',
			}
		]);

		addBlockTranslations('nb-no', [
			{
				output: 'AI Editor',
				id: 'Haldor.Blocks.AIEditor',
			}
		]);

		addBlockTranslations('da-dk', [
			{
				output: 'AI Editor',
				id: 'Haldor.Blocks.AIEditor',
			}
		]);

		addBlockTranslations('uk', [
			{
				output: 'AI Editor',
				id: 'Haldor.Blocks.AIEditor',
			}
		]);
		this.registerResourceType('Haldor.Blocks.AIEditor', {
			visible: 'boolean',
		});

	}

	getDescription = (description) => {
		try {
			description = description.replace(/amp;/g, '');
			description = description.replace(/amp;wd/g, '');
			description = description.replace(/&lt;/g, '<');
			description = description.replace(/&gt;/g, '>');
			description = description.replace(/\<\/b\>/ig, ' </b>');
			description = description.replace(/\<\/i\>/ig, ' </i>');
			description = description.replace(/\<\/a\>/ig, ' </a>');
			description = description.replace(/\<\/p\>/ig, ' </p>');
		} catch (error) {
			description = description;
		}

		return description;
	};
	toggleModal = () => {
		this.setState({ modal: !this.state.modal });
	}
	onSubmit = (values) => {
		console.log('values', values);
	}
	onDataFromPrompt = (data) => {
		this.events.values.change(data);
	}
	consume = (props) => {
		return (
			<div
				className="block--editor consume"
				dangerouslySetInnerHTML={{
					__html: DOMPurify.sanitize(this.getDescription(props.value)),
				}}
			/>
		);
	}

	edit = (props) => {
		const editor = this.api.getEditor();
		const translate = editor.getProp('translate');
		const selectedCoreContent = editor.getProp('selectedCoreContent');
		const sections = editor.getProp('sections');
		const user = new User(editor.getProp('user'));
		let text = this.state.textvalue;
		return (
			<div>
				{!user.isAIEditor() ? <div className="info-description" style={{ margin: '0.5rem' }}><Icon name="Alert" bw /> {this.props.translate('You do not have the correct role to use the AI Editor functionality. It must be activated for you by your Haldor admin.')}</div>
					:
					<div>
						<div className="block--editor">
							<HTMLEditor
								input={{
									onChange: (value) => this.events.values.change(value),
									onBlur: (value) => { },
									value: props.value,
								}}
								meta={{ touched: false, error: false, warning: false }}
								placeholder={translate('Write text or use AI assistance')}
							/>
						</div>
						<AIPrompt
							links={props.resources}
							selectedCoreContent={selectedCoreContent}
							sections={sections}
							onSubmit={this.onSubmit}
							onDataSend={this.onDataFromPrompt}
							block={this}
							text={props.value}
						/>
					</div>
				}
			</div>
		)
	}
}

export default AIEditor;